import { ref, onMounted } from '@vue/composition-api';
export default (ctx) => {
    const firstFocusableElement = ref(null);
    const lastFocusableElement = ref(null);
    const focusableElements = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'iframe',
        'object',
        'embed',
        '[tabindex="0"]',
        '[contenteditable]'
    ];
    const focusableElementsQuery = focusableElements.join(',');
    onMounted(() => {
        const modal = ctx.refs.modal;
        const modalFocusableElements = [
            ...modal.querySelectorAll(focusableElementsQuery)
        ];
        firstFocusableElement.value = modalFocusableElements[0]; // eslint-disable-line
        lastFocusableElement.value = modalFocusableElements[modalFocusableElements.length - 1];
        if (firstFocusableElement.value) {
            firstFocusableElement.value.focus();
        }
    });
    const focusTrap = (event) => {
        const isTabPressed = event.code === 'Tab' || event.keyCode === 9 || event.which === 9;
        const isEscPressed = event.code === 'Escape' || event.keyCode === 27 || event.which === 27;
        const isShiftPressed = event.shiftKey;
        const { activeElement } = document;
        if (isTabPressed) {
            if (isShiftPressed) {
                if (activeElement === firstFocusableElement.value) {
                    event.preventDefault();
                    if (lastFocusableElement.value) {
                        lastFocusableElement.value.focus();
                    }
                }
            }
            else if (activeElement === lastFocusableElement.value) {
                event.preventDefault();
                if (firstFocusableElement.value) {
                    firstFocusableElement.value.focus();
                }
            }
        }
        if (isEscPressed) {
            ctx.emit('esc-pressed');
        }
    };
    return { focusTrap };
};
